angular.module('app').factory('CurrentUserRepository',
    ['storage', '$timeout', 'LocalStorageRepository',
        function (storage) {
            'use strict';

            function removeActiveUser() {
                storage.remove('activeUser');
            }

            function getActiveUser() {
                var activeUser = storage.get('activeUser');
                return {
                    id: activeUser && activeUser.id,
                    fullName: activeUser && activeUser.fullName,
                    userName: activeUser && activeUser.userName,
                    activeDirectoryUser: activeUser && activeUser.activeDirectoryUser
                };
            }

            function setActiveUser(id, firstName, lastName,  userName, activeDirectoryUser) {
                var activeUser = {
                    id: id,
                    fullName: firstName + ' ' + lastName,
                    userName: userName,
                    activeDirectoryUser: activeDirectoryUser
                };

                storage.set('activeUser', activeUser);
            }

            return {
                getActiveUser : getActiveUser,
                setActiveUser : setActiveUser,
                removeActiveUse : removeActiveUser
            };
     }
]);
